import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/agent-avg-earnings.svg'


const _hoisted_1 = { class: "card custom-shadow rounded-3 bg-white border mb-4" }
const _hoisted_2 = { class: "custom-padding-30" }
const _hoisted_3 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_4 = {
  class: "tab-pane fade show active",
  id: "ethereum1-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "ethereum1-tab",
  tabindex: "0"
}
const _hoisted_5 = { style: {"margin":"-30px -5px 0 -21px"} }
const _hoisted_6 = {
  class: "tab-pane fade",
  id: "ethereum2-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "ethereum2-tab",
  tabindex: "0"
}
const _hoisted_7 = { style: {"margin":"-30px -5px 0 -21px"} }
const _hoisted_8 = {
  class: "tab-pane fade",
  id: "ethereum3-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "ethereum3-tab",
  tabindex: "0"
}
const _hoisted_9 = { style: {"margin":"-30px -5px 0 -21px"} }
const _hoisted_10 = {
  class: "tab-pane fade",
  id: "ethereum4-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "ethereum4-tab",
  tabindex: "0"
}
const _hoisted_11 = { style: {"margin":"-30px -5px 0 -21px"} }
const _hoisted_12 = {
  class: "tab-pane fade",
  id: "ethereum5-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "ethereum5-tab",
  tabindex: "0"
}
const _hoisted_13 = { style: {"margin":"-30px -5px 0 -21px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AgentAvgEarningsChart = _resolveComponent("AgentAvgEarningsChart")!
  const _component_AgentAvgEarningsTwoChart = _resolveComponent("AgentAvgEarningsTwoChart")!
  const _component_AgentAvgEarningsThreeChart = _resolveComponent("AgentAvgEarningsThreeChart")!
  const _component_AgentAvgEarningsFourChart = _resolveComponent("AgentAvgEarningsFourChart")!
  const _component_AgentAvgEarningsFiveChart = _resolveComponent("AgentAvgEarningsFiveChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center gap-1 pb-2 mb-4\"><h3 class=\"mb-0 fw-semibold\">Agent Avg. Earnings</h3><div class=\"dropdown action-opt\"><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-vertical\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"clock\"></i> Today </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"pie-chart\"></i> Last 7 Days </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"rotate-cw\"></i> Last Month </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"calendar\"></i> Last 1 Year </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"bar-chart\"></i> All Time </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash\"></i> Delete </a></li></ul></div></div>", 1)),
      _cache[6] || (_cache[6] = _createElementVNode("ul", {
        class: "nav nav-tabs justify-content-between ethereum-rate-tabs",
        id: "myTab",
        role: "tablist"
      }, [
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link active fw-normal",
            style: {"font-size":"14px"},
            id: "ethereum1-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#ethereum1-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "ethereum1-tab-pane",
            "aria-selected": "true"
          }, " 1d ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link fw-normal",
            style: {"font-size":"14px"},
            id: "ethereum2-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#ethereum2-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "ethereum2-tab-pane",
            "aria-selected": "false"
          }, " 15d ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link fw-normal",
            style: {"font-size":"14px"},
            id: "ethereum3-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#ethereum3-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "ethereum3-tab-pane",
            "aria-selected": "false"
          }, " 1m ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link fw-normal",
            style: {"font-size":"14px"},
            id: "ethereum4-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#ethereum4-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "ethereum4-tab-pane",
            "aria-selected": "false"
          }, " 6m ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link fw-normal",
            style: {"font-size":"14px"},
            id: "ethereum5-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#ethereum5-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "ethereum5-tab-pane",
            "aria-selected": "false"
          }, " 1y ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_AgentAvgEarningsChart)
          ]),
          _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex align-items-center position-relative z-1 justify-content-between\"><div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><div class=\"bg-body-bg border text-center rounded-2\" style=\"width:48px;height:48px;line-height:48px;\"><img src=\"" + _imports_0 + "\" alt=\"agent-avg-earnings\"></div></div><div class=\"flex-grow-1 ms-3\"><h3 class=\"fs-28 fw-semibold text-secondary mb-0\">$2,534</h3><span class=\"text-body d-block\">Last month earning</span></div></div><span class=\"d-flex align-items-center align-items-center text-body\"><i class=\"material-symbols-outlined fs-18 pe-2 text-success-60\"> trending_up </i><span class=\"fw-medium me-1 text-secondary\">+8.7%</span></span></div>", 1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_AgentAvgEarningsTwoChart)
          ]),
          _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"d-flex align-items-center position-relative z-1 justify-content-between\"><div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><div class=\"bg-body-bg border text-center rounded-2\" style=\"width:48px;height:48px;line-height:48px;\"><img src=\"" + _imports_0 + "\" alt=\"agent-avg-earnings\"></div></div><div class=\"flex-grow-1 ms-3\"><h3 class=\"fs-28 fw-semibold text-secondary mb-0\">$3,456</h3><span class=\"text-body d-block\">Last month earning</span></div></div><span class=\"d-flex align-items-center align-items-center text-body\"><i class=\"material-symbols-outlined fs-18 pe-2 text-success\"> trending_up </i><span class=\"fw-medium me-1 text-secondary\">+8.7%</span></span></div>", 1))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_AgentAvgEarningsThreeChart)
          ]),
          _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"d-flex align-items-center position-relative z-1 justify-content-between\"><div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><div class=\"bg-body-bg border text-center rounded-2\" style=\"width:48px;height:48px;line-height:48px;\"><img src=\"" + _imports_0 + "\" alt=\"agent-avg-earnings\"></div></div><div class=\"flex-grow-1 ms-3\"><h3 class=\"fs-28 fw-semibold text-secondary mb-0\">$1,753</h3><span class=\"text-body d-block\">Last month earning</span></div></div><span class=\"d-flex align-items-center align-items-center text-body\"><i class=\"material-symbols-outlined fs-18 pe-2 text-success\"> trending_up </i><span class=\"fw-medium me-1 text-secondary\">+4.7%</span></span></div>", 1))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_AgentAvgEarningsFourChart)
          ]),
          _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"d-flex align-items-center position-relative z-1 justify-content-between\"><div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><div class=\"bg-body-bg border text-center rounded-2\" style=\"width:48px;height:48px;line-height:48px;\"><img src=\"" + _imports_0 + "\" alt=\"agent-avg-earnings\"></div></div><div class=\"flex-grow-1 ms-3\"><h3 class=\"fs-28 fw-semibold text-secondary mb-0\">$6,753</h3><span class=\"text-body d-block\">Last month earning</span></div></div><span class=\"d-flex align-items-center align-items-center text-body\"><i class=\"material-symbols-outlined fs-18 pe-2 text-success\"> trending_up </i><span class=\"fw-medium me-1 text-secondary\">+6.7%</span></span></div>", 1))
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_AgentAvgEarningsFiveChart)
          ]),
          _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"d-flex align-items-center position-relative z-1 justify-content-between\"><div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><div class=\"bg-body-bg border text-center rounded-2\" style=\"width:48px;height:48px;line-height:48px;\"><img src=\"" + _imports_0 + "\" alt=\"agent-avg-earnings\"></div></div><div class=\"flex-grow-1 ms-3\"><h3 class=\"fs-28 fw-semibold text-secondary mb-0\">$5,325</h3><span class=\"text-body d-block\">Last month earning</span></div></div><span class=\"d-flex align-items-center align-items-center text-body\"><i class=\"material-symbols-outlined fs-18 pe-2 text-success\"> trending_up </i><span class=\"fw-medium me-1 text-secondary\">+3.7%</span></span></div>", 1))
        ])
      ])
    ])
  ]))
}